import { readFile } from "node:fs/promises";

let cachedVersion: string | undefined;

export async function getPackageVersion() {
  if (cachedVersion !== undefined) {
    return cachedVersion;
  }

  const packageJsonUrl = new URL("../../package.json", import.meta.url);
  const packageJson = JSON.parse(await readFile(packageJsonUrl, "utf8")) as {
    version?: unknown;
  };

  if (typeof packageJson.version !== "string" || packageJson.version.length === 0) {
    throw new Error("Unable to resolve package version from package.json");
  }

  cachedVersion = packageJson.version;
  return cachedVersion;
}
